import MobxReactForm from 'mobx-react-form';
import validatorjs from 'validatorjs';

const plugins = { dvr: validatorjs };

const fields = ['isDoubleEnded', 'estimatedCloseDate', 'fileSubmissionDate'];

const labels = {
    isDoubleEnded: 'This is a Double Ended',
    estimatedCloseDate: 'Estimated Close Date',
    fileSubmissionDate: 'Acceptance Date',
};

const rules = {
    isDoubleEnded: 'required',
    estimatedCloseDate: 'required',
    fileSubmissionDate: 'required',
};
const extra = {
    estimatedCloseDate: 'date',
    fileSubmissionDate: 'date',
};

export default function() {
    return new MobxReactForm({ fields, labels, rules, extra }, { plugins });
}



// WEBPACK FOOTER //
// ./src/workflow/steps/convert-listing-step-form.js